import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { PackBySlugOrGuid } from 'apollo/pack/pack.gql';
import { getSanitizeSlug } from 'helpers/getSanitizeSlug';
import {
    PackBySlugOrGuidQuery,
    PackBySlugOrGuidQueryVariables,
} from 'types/generated/graphql';
import { DynamicMetadata } from '../DynamicMetadata/DynamicMetadata';
import { useGetPackSeoFallback } from './hooks/useGetPackSeoFallback';

export const usePackDetails = () => {
    const { slug } = useParams<{ slug: string }>();
    const { data } = useQuery<
        PackBySlugOrGuidQuery,
        PackBySlugOrGuidQueryVariables
    >(PackBySlugOrGuid, {
        variables: { packSlugOrGuid: getSanitizeSlug(slug) },
    });

    const { name = '', artworkUrl, artist, isFree = false } = data?.pack || {};
    const { titleFallback, descriptionFallback } = useGetPackSeoFallback({
        artistName: artist?.name,
        isFree,
        packName: name,
    });

    if (!data?.pack?.name) {
        return {};
    }

    return {
        title: titleFallback,
        description: descriptionFallback,
        imageUrl: artworkUrl,
    };
};

export const PackDetails = () => {
    const { title, description, imageUrl } = usePackDetails();

    if (!title || !description) {
        return null;
    }

    return (
        <DynamicMetadata
            imageUrl={imageUrl}
            titleFallback={title}
            descriptionFallback={description}
        />
    );
};
